import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import NavigationBar from '@ui-parts/NavigationBar';
import Footer from '@ui-parts/Footer';

import useHandleLogout from '@functional/useHandleLogout';
import { HEADER } from '~/assets/styles/base';

const StyledBody = styled.div`
  min-height: 100vh;
  position: relative;
  padding-bottom: 60px;
  box-sizing: border-box;
`;

interface PrivatePageWrapperProps {
  children: ReactNode;
}

const PrivatePageWrapper = ({ children }: PrivatePageWrapperProps) => {
  const handleLogout = useHandleLogout({
    isAdmin: false,
  });

  return (
    <StyledBody>
      <NavigationBar
        height={HEADER.navigationBar.height}
        handleLogout={handleLogout}
        bgColor={HEADER.navigationBar.bgColor.user}
      />
      {children}
      <Footer />
    </StyledBody>
  );
};

PrivatePageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivatePageWrapper;
